import { NavLink } from 'react-router-dom'
import { useAdminSidebar } from '../../../../Hooks/useAdminSidebar'
import classes from './Sidebar.module.css'
import { RiLogoutBoxRLine } from 'react-icons/ri'
import { connect } from 'react-redux'
import { logout } from '../../../../Redux/userReducer'
const Sidebar = ({ logout }) => {
    const items = useAdminSidebar()
    return <nav className={classes.main} aria-label="Адміністрування">
        {items.map(item => <NavLink key={item.href} to={item.href} end={item.href === '/'} className={({ isActive }) => `${classes.link} ${isActive ? classes.active : ''}`}>
            {item.icon}<span>{item.title}</span>
        </NavLink>)}
        <button type="button" className={`${classes.link} ${classes.logout}`} onClick={logout}><RiLogoutBoxRLine /><span>Exit</span></button>
    </nav>
}
export default connect(null,{ logout })(Sidebar)
